import WindowGridIcon from "./window-grid-icon.svg";
import ArrowRightIcon from "./arrow-right-icon.svg";
import ArrowCodeIcon from "./arrow-code-icon.svg";
import PenIcon from "./pen-icon.svg";
import CheckedCircleIcon from "./checked-circle-icon.svg";
import GraduationCapIcon from "./graduation-cap-icon.svg";
import WorkIcon from "./work-icon.svg";
import CalendarGreyIcon from "./calendar-grey-icon.svg";
import WorkGreyIcon from "./work-grey-icon.svg";
import GraduationGreyIcon from "./graduation-cap-grey-icon.svg";
import simran from "./simran1.jpeg";
import rohan from "./rohan1.jpeg";
import AZ900 from "./AZ900.png";
import SC900 from "./SC900.png";
import First from "../Images/Pictures/First.jpg";
import Second from "../Images/Pictures/second.jpg";
import Third from "../Images/Pictures/third.jpg";

export const AllImages = {
  WindowGridIcon,
  ArrowRightIcon,
  ArrowCodeIcon,
  PenIcon,
  CheckedCircleIcon,
  GraduationCapIcon,
  WorkIcon,
  CalendarGreyIcon,
  WorkGreyIcon,
  GraduationGreyIcon,
  simran,
  AZ900,
  SC900,
  First,
  Second,
  Third,
  rohan,
};
